import {
  GraduationCap,
  TrendingUp,
  Users,
  Languages,
  Timer,
  Star
} from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const schoolBenefits = [
  {
    icon: <GraduationCap className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-600",
    title: "AI Teaching Tools worth ₹5 Lakh Free for the 1st Year"
  },
  {
    icon: <TrendingUp className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-600",
    title: "Up to ₹2.5 Crore in new admissions revenue"
  },
  {
    icon: <Users className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-600",
    title: "Up to 1 Lakh+ Parent Reach via daily automated branding"
  },
  {
    icon: <Languages className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-600",
    title: "Daily engagement with parents in 10+ languages"
  },
  {
    icon: <Timer className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-600",
    title: "Full setup and onboarding in under 10 minutes"
  },
  {
    icon: <Star className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-600",
    title: "Only 1% of schools per state onboarded"
  }
];


export default function WhySchoolOwnersTrust() {

  return (
    <>
      <Box
        badge={"WHAT WE DELIVER"}
        title={"Why School Owners Trust SooMuch.ai"}
        description={"Teaching isn’t business — it’s legacy. We contribute tools and limit onboarding for true impact."}
        leftBlock={
          <div className='col-span-2 md:col-span-1'>
            {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
            <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
              {schoolBenefits.slice(0, 3).map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
            </div>
          </div>
        }
        rightBlock={<div className='col-span-2 md:col-span-1'>
          {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
          <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
            {schoolBenefits.slice(3).map((member, index) => <MarktingCard key={"memberasdasdInnerCard" + index} member={member} />)}
          </div>
        </div>}
      />

    </>
  );
}